import styled from 'styled-components';

import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { Paragraph } from 'design-system/components/Text';

interface BizVerificationCompleteProps {
  onClose: () => void;
}

const BizVerificationComplete = ({ onClose }: BizVerificationCompleteProps) => {
  return (
    <StyledModalContainer>
      <ModalHeader onClose={onClose}>We’ve received your request</ModalHeader>
      <ModalBody>
        <Paragraph size='lg' color='primary'>
          Our team will review your request, and you’ll receive updates on the status of your
          request via email.
        </Paragraph>
      </ModalBody>
    </StyledModalContainer>
  );
};

const StyledModalContainer = styled(ModalContainer)`
  min-width: 700px;
`;

export default BizVerificationComplete;
